import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  blockingLoader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100
  }
});

export default styles;